import { formDecorator } from '../../Common/forms'

export const LISTING_QUERY_FORM_CONFIG = {
  form: 'listingQueryForm',
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // unregister fields on unmount
  // validate: syncValidator,
  asyncBlurFields: []
  // onChange: onProposalListingFormChange
}

const withListingQueryForm = wrappedComponent => formDecorator(LISTING_QUERY_FORM_CONFIG)(wrappedComponent)

export default withListingQueryForm
